// @ts-nocheck

export function apenasNumeros(_string:string)
{                                          
    if(_string.match(/^[0-9]+$/) != null){
        return true;
    } else {
        return false;
    }
}       

export function safeStr(_string:string, def="")
{         

    let ret = def;                                    
    if(_string != null || _string != undefined || _string != NaN){
        if( String(_string).length > 0 ){
          
            if( String(_string).toUpperCase() == "NONE" || 
                String(_string).toUpperCase() == "NULL" || 
                String(_string).toLowerCase() == 'undefined'){
                 
            }else{
                ret = String(_string);    
            }
   
        }
      //  alert(ret)
    }
    return ret;
}     

export function safeInt(_string:string, def=0)
{         
    let ret = def;                                    
    if(_string != null || _string != NaN || _string != undefined ){
        let str = String(_string); 
        if(str.split(".").length - 1 >= 1){
            ret = parseInt(str.split(".")[0]) || def;
        }else if (str.split(",").length - 1 >= 1 ){
            ret = parseInt(str.split(",")[0]) || def;
        }else{
            ret = parseInt(_string) || def;
        }
    }
    return ret;
}    


export function safeBol(_boolean:string, def=false)
{         
    let ret = def;                                 
    if(_boolean != null){
        if( _boolean === "1" ){        
            ret = true;    
        }else{
            if( _boolean === 1 ){        
                ret = true;    
            }else{
                if( _boolean === true ){        
                    ret = true;    
                }
            }
        }
   
    }
    return ret;
}    

export function getInGlobal(_string="")
{
    let res = "";
    if(_string.length > 0){
       let obj = JSON.parse(localStorage.getItem("cfg_global"));
       if(obj && obj[_string]){
        res = String(obj[_string]);
       }else{
           res =  String(_string.replaceAll("_"," ")).toUpperCase();
       }
    }
    
    return res;
}



export function bolToInt(_boolean, def=0)
{         
    let ret = def;     
    //alert(_boolean)                            
    if(_boolean != null){
        if( _boolean === true ){        
            ret = 1;    
        }
   
    }
    return ret;
}    

export function realToFloat(_real:string, def:number=0.0)
{         
    //alert("R>"+_real)
    let ret:number = def;     
    let str = safeStr(_real, def="");   
                        
    if(str != null && str.length > 0){  
        /* 
        12.500,95
        25.159,954
           520,50
           520,514

        1000.00
        1000.512
       2,100.21
       */
      /*
        let virgulas = str.split(",").length-1; 
        let pontos = str.split(".").length-1; 

        if(virgulas == 1 && pontos == 0){
            ret = parseFloat(parseFloat(String(str).replace(',', '.')).toFixed(2));   
        }else if(virgulas == 0 && pontos == 1){
            ret = parseFloat(parseFloat(String(str)).toFixed(2)); 
        }else if(virgulas == 1 && pontos >= 2){
            ret = parseFloat(parseFloat( String(str).replace('.', '').replace(',', '.')).toFixed(2));  
        }else if(virgulas >= 2 && pontos == 1){
            ret = parseFloat(parseFloat( String(str).replace(',', '')).toFixed(2));  
        }else if(virgulas == 1 && pontos == 1){
            ret = parseFloat(parseFloat( String(str).replace('.', '').replace(',', '.')).toFixed(2)); 
        }else if(virgulas == 0 && pontos == 0){
            ret = parseFloat(parseFloat( String(str)).toFixed(2)); 
        }
       */
        ret = parseFloat(parseFloat( String(str).replace('.', '').replace(',', '.')).toFixed(2));   
      // ret = parseFloat(parseFloat( String(str)).toFixed(2));  
    }
   // alert("RR>"+ret)
    return ret;
}    

export function arredondarDec(_real:number, def:number=2)
{         alert(parseFloat(parseFloat(_real).toFixed(2)));
    if (_real < 0.0) { _real = 0.0 } 
    let ret:number = parseFloat(parseFloat(_real).toFixed(2));                       
    return ret;
}    

export function floatToReal(_real:number, dec:string="", deb:boolean=false)
{       
    //_real = arredondarDec(_real);
    if(deb){alert("A:"+_real); }  
    
    let ret:string = _real.toLocaleString('pt-br', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    if (ret == "0" || ret.length <= 0){
        ret = "0,00"
    }
    if(deb){alert("R:"+ret); }                             
    return ret;
}    


export function findStrInList(lista, busca_col, busca_valor, res_col)
{
  
    let res = "";
    let oob = lista.find((e) => e[busca_col] == busca_valor);
    if(oob){
        res = safeStr(oob[res_col]);

    }
    return res;
}


export function findIntInList(lista, busca_col, busca_valor, res_col, def=-1)
{
    let res = def;
    let oob = lista.find((e) => e[busca_col] == busca_valor);
    if(oob){
        res = parseInt(oob[res_col]);

    }
    return res;
}